import React from "react";
import "./footer.css";
//import Navbar from 'react-bootstrap/Navbar';

class Footer extends React.Component {
    render() {
        return ( <footer id = "footerBar" className = "" >
         </footer>);
    }
}

export default Footer;
